var map = {
	"./ic-dropdown-arrow.svg": "b256",
	"./icon-add-phone-number.svg": "0094",
	"./icon-arrow-down.svg": "1f71",
	"./icon-arrow-left.svg": "4ccb",
	"./icon-attachment.svg": "b88d",
	"./icon-battery.svg": "651b",
	"./icon-cellular.svg": "5b62",
	"./icon-check-mark.svg": "f0a0",
	"./icon-download.svg": "3e18",
	"./icon-electricity.svg": "5fba",
	"./icon-error.svg": "b266",
	"./icon-file.svg": "fc1b",
	"./icon-filter.svg": "518d",
	"./icon-fire.svg": "1558",
	"./icon-heat.svg": "cc79",
	"./icon-image.svg": "8148",
	"./icon-logout.svg": "8301",
	"./icon-mail.svg": "50004",
	"./icon-map-pin.svg": "a2f0",
	"./icon-navigation-main.svg": "f2a0",
	"./icon-no-appeals.svg": "add5",
	"./icon-org-appeal.svg": "bffc",
	"./icon-org-contact.svg": "82ec",
	"./icon-org-default.svg": "711d",
	"./icon-phone.svg": "2287",
	"./icon-repair.svg": "5d4b",
	"./icon-rubbish.svg": "0eea",
	"./icon-search.svg": "c755",
	"./icon-settings.svg": "cad9",
	"./icon-table-sort.svg": "f253",
	"./icon-water.svg": "7b0f",
	"./icon-web-site.svg": "bd28",
	"./icon-wifi.svg": "c6c0",
	"./logo.svg": "aa0d",
	"./map-pin.svg": "c7b2",
	"./profile-logo.svg": "13cf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "65a8";